import importAll from 'import-all.macro';
import raw from 'raw.macro';
import { IoMdLock, IoMdMenu } from 'react-icons/io';
import { Link } from 'react-router-dom';
import HomeLayout from '../../layouts/HomeLayout';
import { getRoutes } from '../../utils';
import Markdown from '../../components/Markdown';
import Section from '../../components/Section';
import styles from './Terms.module.scss';

const sections = getRoutes(importAll.sync('../Landing/*/index.tsx'));

function Terms() {
  return (
    <HomeLayout
      navProps={{
        actions: [
          {
            variant: 'solid',
            children: 'Back to Home',
            buttonColor: 'primary-1',
            to: '/',
            as: Link,
          },
        ],
      }}
      footerItems={[
        {
          label: 'Navigation',
          items: sections.map((section) => ({
            to: `/#${section.routeProps?.path ?? ''}`,
            children: section.routeProps?.label,
            onClick() {
              const id = section.routeProps?.path?.replace(/[/#]/g, '');
              if (!id) return;

              window.setTimeout(() => {
                const el = document.getElementById(id);
                window.scrollTo(0, el?.offsetTop ?? 0);
              }, 10);
            },
          })),
        },
        {
          label: 'Legal',
          items: [
            {
              children: 'Privacy Policy',
              to: '/privacy',
              icon: IoMdLock,
            },
            {
              children: 'Terms & Conditions',
              to: '/terms',
              icon: IoMdMenu,
            },
          ],
        },
        {
          label: 'Account',
          items: [
            {
              children: 'Dashboard',
              to: '/home',
            },
          ],
        },
      ]}
    >
      <Section>
        <Markdown className={styles.doc}>{raw('./data.md')}</Markdown>
      </Section>
    </HomeLayout>
  );
}

Terms.routeProps = {
  path: '/terms',
};

export default Terms;
